import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './Pages/Login';
import SupervisorDashboard from './Pages/Supervisor/SupervisorDashboard';
import EmployeeDashboard from './Pages/Employee/EmployeeDashboard';
import { AuthProvider } from './Components/Contexts/AuthContext';
import ProtectedRoute from './Components/Contexts/ProtectedRoute';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="h-screen w-screen flex items-center justify-center bg-gray-100 overflow-hidden">
          <Routes>
            {/* Public Route */}
            <Route path="/" element={<Login />} />

            {/* Protected Routes */}
            <Route
              path="/supervisor"
              element={
                <ProtectedRoute>
                  <SupervisorDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/employee"
              element={
                <ProtectedRoute>
                  <EmployeeDashboard />
                </ProtectedRoute>
              }
            />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
